export default __webpack_public_path__ + "static/real-time-09bd9b33c1746d158f9b30018c5c64e6.png";